// Package Imports
import React, { Suspense, lazy } from 'react';
import { Route } from 'react-router-dom';

// Project Imports
import routeName from 'core/common/routeName';
import resourceName from 'core/common/resourceName';
import PrivateRoute from 'core/utils/PrivateRoute';
import Loading from 'components/loading/loading';
// Lazy-loaded Component
const Dashboard = lazy(() => import('pages/dashboard/dashboard'));

const DashboardRoute = (
  <Route
    path={routeName.dashboard}
    element={
      <PrivateRoute name={resourceName.dashboard}>
        <Suspense fallback={<Loading />}>
          <Dashboard />
        </Suspense>
      </PrivateRoute>
    }
  />
);

export default DashboardRoute;
